<template>
  <b-dropdown
    position="is-bottom-left"
    :mobile-modal="false"
  >
    <template #trigger="{ active }">
      <div class="dropdown_button">
        <app-avatar :user-id="userId" position="is-left"></app-avatar>
        <icon-default icon="dropdown"></icon-default>
      </div>
    </template>

    <template v-for="link in accountLinks">
      <a v-if="link.show" class="navbar-item" @click="openTypeModal(link.href)">
        {{ link.label }}
      </a>
    </template>

    <hr class="navbar-divider">

    <a
      class="navbar-item flex flex-between"
      href="https://help.forefrontcrm.com/"
      target="_blank"
    >Help Docs <icon-default icon="external_link" size="is-small"/></a>
    <p class="navbar-message">Or email us at <a href="mailto:support@forefrontcrm.com">support@forefrontcrm.com</a></p>

    <hr class="navbar-divider">

    <a
      class="navbar-item"
      @click="logout"
    >Logout</a>
  </b-dropdown>
</template>

<script>
import localStorageService from "../../../services/localStorage";
import auth from "../../../api/auth";
import router from "../../../router";
import { ENUMS } from "../../../services/enums";

export default {
  name: "PageHeaderUserMenu",
  data() {
    return {
      isProfileMenuShowing: false,
    };
  },
  computed: {
    accountLinks() {
      return [
        {
          href: "profile",
          label: "Profile",
          show: this.canManageProfile
        },
        {
          href: "users",
          label: "Users",
          show: this.canManageUsers
        },
        {
          href: "account",
          label: "Account & Billing",
          show: this.canManageAccount
        }
      ];
    },
    activeUser() {
      return this.$store.getters.authUser;
    },
    isOwner() {
      return this.activeUser.is_owner;
    },
    canManageProfile() {
      return this.activeUser.type === ENUMS.UserTypeEnum.Account.value;
    },
    canManageAccount() {
      return this.isOwner || this.activeUser.can_manage_account;
    },
    canManageUsers() {
      return this.isOwner || this.activeUser.can_manage_users;
    },
    userId() {
      return localStorageService.getAuthUser().id;
    },
  },
  methods: {
    openTypeModal(type) {
      router.replace({query: {modal: type}});
    },
    logout() {
      auth.logout().then(() => {
        router.push({ name: 'login' });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.dropdown_button {
  display: flex;
  align-items: center;
  cursor: pointer;

  .avatar {
    cursor: pointer;
  }
}

.navbar-message {
  padding: 0 0.75rem;
  color: $text-muted;
  font-size: 0.75rem;
  line-height: 1.2;
}

</style>
